module.exports = __webpack_public_path__ + "static/img/login_box_bg.167effb1.png";